"use strict";

// @codekit-append './bower_components/glidejs/dist/glide.min.js'
// @codekit-append './bernethe_libs/bernethe.js'

var _cSlid, _tSlid, interSlid, _sAll;

function setup_main_web(eAI) {
	let _ctp = document.body.dataset.cp;
	if( document.getElementById('contact_form') != null ) {
		document.getElementById('contact_form').addEventListener('submit',doContactForm,!1);
	}

	if(document.querySelector('.slider') != null) {
		if(document.querySelectorAll('.slider .slide').length > 1) {
			slideSlider();
		}
	}

	//console.log(_ctp);
	if( _ctp != '' && window['setup_'+_ctp] != undefined ) {
		window['setup_'+_ctp]();
	}
}
function slideSlider() {
	_sAll = document.querySelectorAll('.slider .slide');
	_cSlid = 0;
	_tSlid = 7500;
	for(let i = 1; i < _sAll.length; i++) {
		_sAll[i].classList.add('slide-to-right');
		//console.log(_sAll[i]);
	}
	interSlid = setInterval(() => {
		for(let i = 0; i < _sAll.length; i++) {
			_sAll[_cSlid].classList.add('slide-to-right');
		}
		_cSlid++;
		if(_cSlid >= _sAll.length) {
			_cSlid = 0;
		}
		_sAll[_cSlid].classList.remove('slide-to-right');
	}, _tSlid);
}
function setup_home() {
	document.getElementById('clients_btn').addEventListener('click', (eCL) => {
		eCL.preventDefault();
		document.getElementById('clients_btn').parentElement.parentElement.style.display = 'none';
		document.querySelector('ul.clients').classList.add('opened')
	}, !1);
	setup_team();
	setup_contact();
}
function setup_work() {
	new Glide('.glide-work-1').mount();
	new Glide('.glide-work-2').mount();
	new Glide('.glide-work-3').mount();
	new Glide('.glide-work-4').mount();
}
function setup_team() {}
function setup_contact() {}
function setup_influencers() {
	document.getElementById('influencers_form').addEventListener('submit',doInfluencersForm,!1);
}

function doInfluencersForm(eDIF) {
	eDIF.preventDefault();

	var _m = '';
	var _rrss = 0;

	if( document.getElementById('name_i_txt').value.length < 2 ) {
		_m += '<li>El NOMBRE COMPLETO es requerido</li>';
	}
	if( !email_rx.test(document.getElementById('email_i_txt').value) ) {
		_m += '<li>El CORREO ELECTRÓNICO es requerido</li>';
	}
	if( document.getElementById('phone_i_txt').value.length < 2 ) {
		_m += '<li>El TELÉFONO es requerido</li>';
	}
	if( document.getElementById('categ_txt').value.length < 2 ) {
		_m += '<li>La(s) CATEGORÍA(S) son requeridas</li>';
	}

	if( document.getElementById('fb_txt').value.length > 2 ) {
		_rrss++;
	}
	if( document.getElementById('ig_txt').value.length > 2 ) {
		_rrss++;
	}
	if( document.getElementById('yt_txt').value.length > 2 ) {
		_rrss++;
	}
	if( document.getElementById('otras_rrss_txt').value.length > 2 ) {
		_rrss++;
	}
	if( _rrss == 0 ) {
		_m += '<li>Debe poner como mínimo una DIRECCIÓN DE REDES</li>';
	}

	if( _m != '' ) {
		appendModal('<p>Los datos solicitados están incompletos:</p><ul>'+_m+'</ul>', 'Atención');
	} else {
		appendPreloader('Procesando Datos');
		let fd = new FormData(document.getElementById('influencers_form'));
		fd.append('type_txt', 'influencers');
		fd.append('f', Date.now());
		
		fetch('/do-contact/', {
			method: 'POST',
			headers: {
				'Content-type': 'application/x-www-form-urlencoded; charset=UTF-8',
				'pragma': 'no-cache',
				'cache-control': 'no-cache'
			},
			body: new URLSearchParams(fd).toString()
		})
		.then(function (resp) {
			//console.table(resp);
			return resp;
		})
		.then(function (json) {
			console.log(json);
			removePreloader();
			/*
			document.getElementById('name_i_txt').value = '';
			document.getElementById('email_i_txt').value = '';
			document.getElementById('phone_i_txt').value = '';
			document.getElementById('categ_txt').value = '';
			document.getElementById('name_i_txt').value = '';
			document.getElementById('name_i_txt').value = '';
			document.getElementById('name_i_txt').value = '';
			document.getElementById('name_i_txt').value = '';
			document.getElementById('msj_i_txt').value = '';
			*/
		   document.getElementById('influencers_form').reset();
			appendModal('Los datos han sido enviados.','Listo');
		})
		.catch(function (ex) { console.log(ex); });
	}
}

function doContactForm(eDCF) {
	eDCF.preventDefault();

	var _m = '';

	if( document.getElementById('name_txt').value.length < 2 ) {
		_m += '<li>El NOMBRE COMPLETO es requerido</li>';
	}
	if( !email_rx.test(document.getElementById('email_txt').value) ) {
		_m += '<li>El CORREO ELECTRÓNICO es requerido</li>';
	}

	if( _m != '' ) {
		appendModal('<p>Los datos solicitados están incompletos:</p><ul>'+_m+'</ul>', 'Atención');
	} else {
		appendPreloader('Procesando Datos');
		let fd = new FormData(document.getElementById('contact_form'));
		fd.append('type_txt', 'contact');
		fd.append('f', Date.now());
		
		fetch('/do-contact/', {
			method: 'POST',
			headers: {
				'Content-type': 'application/x-www-form-urlencoded; charset=UTF-8',
				'pragma': 'no-cache',
				'cache-control': 'no-cache'
			},
			body: new URLSearchParams(fd).toString()
		})
		.then(function (resp) {
			//console.table(resp);
			return resp;
		})
		.then(function (json) {
			console.log(json);
			removePreloader();
			/*
			document.getElementById('name_txt').value = '';
			document.getElementById('email_txt').value = '';
			document.getElementById('subject_txt').value = '';
			document.getElementById('msj_txt').value = '';
			*/
		   document.getElementById('contact_form').reset();
		   appendModal('Los datos han sido enviados.','Listo');
		})
		.catch(function (ex) { console.log(ex); });
	}
}

document.addEventListener('DOMContentLoaded', setup_main_web, !1);